module.exports = __webpack_public_path__ + "644e05935d08db19c67bbee23f544666.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/14_C#3.mp3
// module id = 54
// module chunks = 0